import { useEffect } from 'react';

/**
 * Событие focus элемента iframe нельзя отследить явным образом,
 * поэтому определяем по активности window: если window блюрится,
 * iframe становится активным
 */
export const useIframeFocus = (focusHandler: () => void) => {
  useEffect(() => {
    window.addEventListener('blur', focusHandler);

    return () => {
      window.removeEventListener('blur', focusHandler);
    };
  }, [focusHandler]);
};
